import CardsPage from './CardsPage'
import ContactPage from './ContactPage'
import DashboardPage from './DashboardPage'
import DeleteAccountPage from './DeleteAccount/DeleteAccountPage'
import InvoicesStatementsPage from './InvoicesStatementsPage'
import LoginPageBankID from './LoginPageBankID'
import LogoutPage from './LogoutPage'
import NotFoundPage from './NotFoundPage'
import ProfileSettingsPage from './ProfileSettingsPage'
import TransactionsPage from './TransactionsPage'
import UserManagementPage from './UserManagementPage'

const Pages = {
  CardsPage,
  ContactPage,
  DeleteAccountPage,
  InvoicesStatementsPage,
  LoginPageBankID,
  LogoutPage,
  NotFoundPage,
  DashboardPage,
  TransactionsPage,
  ProfileSettingsPage,
  UserManagementPage
}

export default Pages
